module.exports = __webpack_public_path__ + "static/media/genesis-building.0e2cc3fc.png";